<div class="diagram">
  <!--<div class="header">-->
  <!--{{'score' | translate}}-->
<!--</div>-->
<div class="body">
  @if (chartData.length && chartColors.length && chartData2.length
    && chartLabels2.length && chartColors2.length) {
    <div class="graph" >
      <div class="main-graph">
        <canvas mdbChart  width="180" height="180"
          [chartType]="chartType"
          [data]="chartData"
          [labels]="chartLabels"
          [colors]="chartColors"
          [options]="chartOptions"
          [legend]="false"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked($event)">
        </canvas>
      </div>
      <div class="border-graph">
        <canvas mdbChart width="180" height="180"
          [chartType]="chartType2"
          [data]="chartData2"
          [labels]="chartLabels2"
          [colors]="chartColors2"
          [options]="chartOptions2"
          [legend]="false"
          (chartHover)="chartHovered2($event)"
          (chartClick)="chartClicked2($event)">
        </canvas>
      </div>
      @if (data) {
        <div class="inside-text">
          <div style="font-size: 40px">{{sum}}/{{data.creditTarget}}</div>
          <div style="font-size: 18px; margin: 15px">Credits gesammelt</div>
        </div>
      }
    </div>
  }
  @if (data && data.subCredit && creditData) {
    <div class="graph-info">
      @for (info of data.subCredit; track info; let i = $index) {
        <div class="info subCredit">
          <div style="display: flex; width: 150px;">
            <div class="color" [style.borderTopColor]="info?.eventType?.color ? info?.eventType?.color : info?.color"></div>
            <div class="name">{{info.eventType.name}}</div>
          </div>
          <div class="text">{{creditData[i]}}/{{info.credit}} Credits</div>
          <div class="text possible-credits" >
            <span>
              {{possibleData[i] > 0 ? '(' + possibleData[i] + ')' : ''}}
            </span>
          </div>
        </div>
      }
      @if (isOther && data && data.subCredit && data.subCredit.length) {
        <div class="info isOther">
          <div style="display: flex; width: 150px;">
            <div class="color" [style.borderTopColor]="'transparent'"></div>
            <div class="name">{{'Other' | translate}}</div>
          </div>
          <div class="text">{{other.count}}/{{other.all}} Credits</div>
          <div class="text possible-credits">
            <span>   {{other.possible > 0 ? '(' + other.possible + ')' : ''}}</span></div>
          </div>
        }
        @for (info of otherArray; track info; let i = $index) {
          <div class="info otherArray">
            <div style="display: flex; width: 150px;">
              <div class="color" [style.borderTopColor]="info?.eventType?.color"></div>
              <div class="name">{{info?.eventType?.name}}</div>
            </div>
            <div class="text">{{info.credits}} Credits</div>
            <div class="text possible-credits" >
              <span></span>
            </div>
          </div>
        }
      </div>
    }

    @if (type === 'full') {
      <div class="code">
        <div class="code-input">
          <label for="input">Redeem code</label>
          <input type="text" id="input">
        </div>
        <input type="button" value="Eintragen" (click)="confirm()">
      </div>
    }
  </div>
</div>
